import { useEffect } from 'react';

export function useNotificationTimeout(start: boolean, onTimeout: () => void, timeout = 1500) {
  useEffect(() => {
    if (start) {
      setTimeout(() => {
        onTimeout();
      }, timeout);
    }
  }, [start]);
}
